import { Component, EventEmitter, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import {
  HubtypeUser,
  STATUS_AVAILABLE,
  STATUS_AWAY,
  STATUS_BUSY,
  STATUS_OFFLINE,
} from 'models/hubtype-user'

export interface FilterUserStatus {
  checked: boolean
  label: string
  labelKey: string
  color: string
  status: string
}

@Component({
  selector: 'filter-user-status',
  templateUrl: './filter-user-status.component.html',
  styleUrls: ['./filter-user-status.component.scss'],
  standalone: false,
})
export class FilterUserStatusComponent {
  @Output()
  statusChange = new EventEmitter<FilterUserStatus[]>()

  userStatus: FilterUserStatus[] = [
    {
      status: STATUS_AVAILABLE,
      checked: true,
      label: this.getLabel(STATUS_AVAILABLE),
      labelKey: 'shared.filterUserStatus.available',
      color: 'green',
    },
    {
      status: STATUS_BUSY,
      checked: true,
      label: this.getLabel(STATUS_BUSY),
      labelKey: 'shared.filterUserStatus.busy',
      color: 'red',
    },
    {
      status: STATUS_AWAY,
      checked: true,
      label: this.getLabel(STATUS_AWAY),
      labelKey: 'shared.filterUserStatus.away',
      color: 'orange',
    },
    {
      status: STATUS_OFFLINE,
      checked: true,
      label: this.getLabel(STATUS_OFFLINE),
      labelKey: 'shared.filterUserStatus.offline',
      color: 'gray',
    },
  ]
  constructor(private translate: TranslateService) {}

  get title() {
    return this.translate.instant('shared.filterUserStatus.title')
  }

  statusLabel(statusFilter: FilterUserStatus) {
    return this.translate.instant(statusFilter.labelKey)
  }

  onCheckStatusChange() {
    this.statusChange.emit(this.userStatus)
  }

  private getLabel(statusFilter: string) {
    return HubtypeUser.statusList.find(status => status.key === statusFilter)
      .label
  }
}
